'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

export const ScrollToTop = () => {
  const pathname = usePathname();

  useEffect(() => {
    // Avoid resetting scroll on specific pages
    if (
      pathname === '/issue' ||
      pathname === '/chatbot' ||
      pathname?.startsWith('/chatbot/')
    ) {
      return;
    }

    const frameId = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });

    return () => cancelAnimationFrame(frameId);
  }, [pathname]);

  return null;
};
